import React from 'react';
import { i18n } from 'config/locales';

import { Summary, DateSummary } from 'components/Summary';
import { SUBSTANCE_USE, SUBSTANCE_USE_DRUGS_CLEARANCE } from 'config/formSections/substanceUse';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';
import DrugClearanceUse from './DrugClearanceUse';

const sectionConfig = {
  key: SUBSTANCE_USE_DRUGS_CLEARANCE.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_DRUGS_CLEARANCE.name,
  storeKey: SUBSTANCE_USE_DRUGS_CLEARANCE.storeKey,
};

export class DrugClearanceUses extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
  }

  update = (updateValues) => {
    this.props.onUpdate(this.storeKey, {
      UsedDrugs: this.props.UsedDrugs,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...updateValues,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateUsedDrugs = (values) => {
    this.update({
      UsedDrugs: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const range = DateSummary(o.InvolvementDates);
    const description = (o.Description || {}).value;

    return Summary({
      type: i18n.t('substance.drugs.clearance.collection.itemType'),
      index,
      left: description,
      right: range,
      placeholder: i18n.t('substance.drugs.clearance.collection.summary'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const isPvq = isPVQForm(this.props.formType);
    return isPvq ? (
      <div
        className="section-content drug-clearance-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_DRUGS_CLEARANCE.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.drugs.clearance')}</h1>
        <Branch
          attribute="UsedDrugs"
          name="UsedDrugs"
          label={i18n.t('substance.pvq.drugs.heading.drugClearanceUses')}
          labelSize="h4"
          className="used-drugs"
          {...this.props.UsedDrugs}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateUsedDrugs}
          scrollIntoView={this.props.scrollIntoView}
        />

        <Show when={this.props.UsedDrugs.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('substance.pvq.drugs.clearance.collection.description')}
            appendTitle={i18n.t('substance.pvq.drugs.clearance.collection.appendTitle')}
            appendLabel={i18n.t('substance.pvq.drugs.clearance.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <DrugClearanceUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <div
        className="section-content drug-clearance-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_DRUGS_CLEARANCE.key}
      >
        <h1 className="section-header">{i18n.t('substance.subsection.drugs.clearance')}</h1>
        <Branch
          attribute="UsedDrugs"
          name="UsedDrugs"
          label={i18n.t('substance.drugs.heading.drugClearanceUses')}
          labelSize="h4"
          className="used-drugs"
          {...this.props.UsedDrugs}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateUsedDrugs}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Comments
          title={i18n.t('substance.comments.optional')}
          name="Comments"
          className="optional-comment"
          attribute="Comments"
          {...this.props.Comments}
          onUpdate={this.updateComments}
          required={false}
        />

        <Show when={this.props.UsedDrugs.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('substance.drugs.clearance.collection.description')}
            appendTitle={i18n.t('substance.drugs.clearance.collection.appendTitle')}
            appendLabel={i18n.t('substance.drugs.clearance.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <DrugClearanceUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
            />
          </Accordion>
          <Comments
            title={i18n.t('substance.comments.summary')}
            name="SummaryComments"
            className="summary-comment"
            attribute="SummaryComments"
            {...this.props.SummaryComments}
            onUpdate={this.updateSummaryComments}
            required={false}
          />
        </Show>
      </div>
    );
  }
}

DrugClearanceUses.defaultProps = {
  UsedDrugs: {},
  List: { items: [], branch: {} },
  Comments: {},
  SummaryComments: {},
  onError: (value, arr) => arr,
  section: 'substance',
  subsection: 'drugs/clearance',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
  formType: '',

};

export default connectSubsection(DrugClearanceUses, sectionConfig);
